/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../html-utils/html.pipe';
import * as import2 from '@angular/platform-browser';
import * as import3 from './receipt.component';
const styles_ReceiptComponent:any[] = ([] as any[]);
export const RenderType_ReceiptComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ReceiptComponent,
  data: {}
}
);
export function View_ReceiptComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import1.HtmlPipe,[import2.DomSanitizer]),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'content'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(null as any),(ck,v) => {
    var co:import3.ReceiptComponent = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,ck(v,2,0,import0.ɵnov(v,0),co.receiptXml));
    ck(v,1,0,currVal_0);
  });
}
function View_ReceiptComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-receipt',([] as any[]),(null as any),(null as any),(null as any),View_ReceiptComponent_0,RenderType_ReceiptComponent)),
    import0.ɵdid(49152,(null as any),0,import3.ReceiptComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const ReceiptComponentNgFactory:import0.ComponentFactory<import3.ReceiptComponent> = import0.ɵccf('woa-receipt',import3.ReceiptComponent,View_ReceiptComponent_Host_0,{receiptXml: 'receiptXml'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvY3VzdG9tZXItaW5mby9yZWNlaXB0L3JlY2VpcHQuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvY3VzdG9tZXItaW5mby9yZWNlaXB0L3JlY2VpcHQuY29tcG9uZW50LnRzIiwibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC9jdXN0b21lci1pbmZvL3JlY2VpcHQvcmVjZWlwdC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvY3VzdG9tZXItaW5mby9yZWNlaXB0L3JlY2VpcHQuY29tcG9uZW50LnRzLlJlY2VpcHRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwiY29udGVudFwiIFtpbm5lckhUTUxdPVwicmVjZWlwdFhtbCB8IGh0bWxcIj48L2Rpdj5cbiIsIjx3b2EtcmVjZWlwdD48L3dvYS1yZWNlaXB0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7TUNBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBcUI7SUFBc0M7Ozs7SUFBdEM7SUFBckIsU0FBcUIsU0FBckI7Ozs7O0lDQUE7Z0JBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/app/customer-info/receipt/receipt.component.ngfactory.ts